import React, { useState } from 'react';
import { faqs } from '../utils/faqs';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Accordion, AccordionItem, AccordionButton, AccordionPanel, Box, Flex, Icon } from '@chakra-ui/react';

const FAQSection = () => {
  const [expandedIndex, setExpandedIndex] = useState<null | number>(null);

  return (
    <Box
      borderRadius="md"
      width={'100%'}
      height={['300px', '300px', '300px', '350px', '400px']}
      overflowY="auto"
      scrollBehavior={'smooth'}
      sx={{
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      <Accordion allowToggle index={expandedIndex as number} onChange={(index) => setExpandedIndex(index as number)}>
        {faqs.map((faq, index) => (
          <AccordionItem key={index} border="none">
            <h2>
              <AccordionButton _expanded={{ bg: 'gray.200' }} p={4} borderBottom="1px solid #ccc">
                <Flex align="center" flex="1">
                  <Icon
                    as={ChevronRightIcon}
                    boxSize={5}
                    mr={3}
                    transition="transform 0.2s"
                    transform={expandedIndex === index ? 'rotate(90deg)' : 'rotate(0deg)'}
                  />
                  <Box
                    textAlign="left"
                    fontWeight="bold"
                    fontSize="md"
                    color={expandedIndex === index ? '#0053E2' : '#001E60'}
                  >
                    {faq.question}
                  </Box>
                </Flex>
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4} fontSize={'small'}>
              <Box
                dangerouslySetInnerHTML={{
                  __html: faq.answer,
                }}
              />
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
};

export default FAQSection;
